import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../directives/disabled/disabled.directive";
import * as i3 from "@angular/forms";
function SimpleModalFooterComponent_Conditional_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "1 item selected");
} }
function SimpleModalFooterComponent_Conditional_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.selectedItemCount, " items selected");
} }
function SimpleModalFooterComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 9)(2, "span", 10);
    i0.ɵɵtemplate(3, SimpleModalFooterComponent_Conditional_1_ng_template_3_Template, 1, 0, "ng-template", 11)(4, SimpleModalFooterComponent_Conditional_1_ng_template_4_Template, 1, 1, "ng-template", 12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngPlural", ctx_r0.selectedItemCount);
} }
function SimpleModalFooterComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "button", 13);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_Conditional_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.deleteHandler.emit()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r0.deleteButtonText);
} }
function SimpleModalFooterComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 14)(2, "input", 15);
    i0.ɵɵlistener("ngModelChange", function SimpleModalFooterComponent_Conditional_3_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.checkboxHandler.emit($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 16)(4, "span", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r0.checkbox.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r0.checkbox.label);
} }
function SimpleModalFooterComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.errorText);
} }
function SimpleModalFooterComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.noteText);
} }
function SimpleModalFooterComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_Conditional_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.cancelHandler.emit()); });
    i0.ɵɵtext(1, " Cancel ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r0.cancelButtonText);
} }
function SimpleModalFooterComponent_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_Conditional_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.secondaryHandler.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.secondaryButtonClasses)("disabled", ctx_r0.disableSecondary)("textContent", ctx_r0.secondaryButtonText);
    i0.ɵɵattribute("data-test-id", ctx_r0.modalTestId ? ctx_r0.modalTestId + "-secondary-button" : ctx_r0.secondaryButtonText);
} }
function SimpleModalFooterComponent_Conditional_10_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "div", 22);
    i0.ɵɵelementEnd();
} }
function SimpleModalFooterComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function SimpleModalFooterComponent_Conditional_10_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.submitHandler.emit()); });
    i0.ɵɵconditionalCreate(1, SimpleModalFooterComponent_Conditional_10_Conditional_1_Template, 2, 0, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.disableSubmission)("ngClass", ctx_r0.submitButtonClasses);
    i0.ɵɵattribute("data-test-id", ctx_r0.modalTestId ? ctx_r0.modalTestId + "-submit-button" : ctx_r0.submitButtonText);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.loading ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.submitButtonText, " ");
} }
/**
 *
 * Simple Modal Footer Component
 *
 * Input Properties:
 *  checkbox: optional object with a label and a value for a checkbox
 *  disableSubmission: Whether the submit button should be disabled or not. Defaults to false
 *  errorText: The text to display when there is an error
 *  noteText: The text to display as a note to the user
 *  selectedItemCount: How many items have been selected in this modal
 *  submitButtonText: The text that should be used for the submit button. Defaults to 'Submit'
 *  cancelButtonText: The text that should be used for the cancel button. Defaults to 'Cancel'
 *  deleteButtonText: The text that should be used for the delete button. If not provided, the delete button will not be shown
 *  showSubmitButton: Whether the submit button should be shown. Defaults to true
 *  showCancelButton: Whether the cancel button should be shown. Defaults to true
 *  modalTestId: A Unique Test id corresponding to the parent modal. Used to set the data-test-id attribute
 *               for the confirm and cancel buttons
 *
 * Output Properties:
 *  cancelHandler: emits when the user clicks Cancel
 *  checkboxHandler: emits the checkbox value when it changes
 *  submitHandler: emits when the user clicks Submit
 *  deleteHandler: emits when the user clicks Delete
 *
 */
export class SimpleModalFooterComponent {
    constructor() {
        this.showSubmitButton = true;
        this.showCancelButton = true;
        this.secondaryButtonClasses = 'btn-primary';
        this.submitButtonClasses = 'btn-primary';
        this.cancelHandler = new EventEmitter();
        this.checkboxHandler = new EventEmitter();
        this.deleteHandler = new EventEmitter();
        this.secondaryHandler = new EventEmitter();
        this.submitHandler = new EventEmitter();
    }
    ngOnInit() {
        this.cancelButtonText = this.cancelButtonText || 'Cancel';
        this.submitButtonText = this.submitButtonText || 'Submit';
        this.disableSubmission = this.disableSubmission || false;
    }
}
SimpleModalFooterComponent.ɵfac = function SimpleModalFooterComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleModalFooterComponent)(); };
SimpleModalFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleModalFooterComponent, selectors: [["ycn-simple-modal-footer"]], inputs: { checkbox: "checkbox", cancelButtonText: "cancelButtonText", disableSecondary: "disableSecondary", disableSubmission: "disableSubmission", errorText: "errorText", noteText: "noteText", deleteButtonText: "deleteButtonText", secondaryButtonText: "secondaryButtonText", selectedItemCount: "selectedItemCount", submitButtonText: "submitButtonText", showSubmitButton: "showSubmitButton", showCancelButton: "showCancelButton", modalTestId: "modalTestId", loading: "loading", secondaryButtonClasses: "secondaryButtonClasses", submitButtonClasses: "submitButtonClasses" }, outputs: { cancelHandler: "cancelHandler", checkboxHandler: "checkboxHandler", deleteHandler: "deleteHandler", secondaryHandler: "secondaryHandler", submitHandler: "submitHandler" }, standalone: false, decls: 11, vars: 8, consts: [[1, "modal-footer", "user-select-none"], [1, "modal-footer-info"], [1, "popupFooter"], [1, "text-red", 3, "textContent"], [1, "modal-footer-info", 3, "textContent"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "textContent"], ["tabindex", "0", "ycnDisabled", "", 1, "btn", 3, "ngClass", "disabled", "textContent"], ["tabindex", "0", "ycnDisabled", "", 1, "btn", 3, "disabled", "ngClass"], [1, "list-metric-counter"], [3, "ngPlural"], ["ngPluralCase", "=1"], ["ngPluralCase", "other"], [1, "btn", "btn-outline", "btn-danger", 3, "click", "textContent"], [1, "custom-control", "custom-checkbox", "text-default"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "textContent"], [1, "btn", "btn-text", 3, "click", "textContent"], ["tabindex", "0", "ycnDisabled", "", 1, "btn", 3, "click", "ngClass", "disabled", "textContent"], ["tabindex", "0", "ycnDisabled", "", 1, "btn", 3, "click", "disabled", "ngClass"], [1, "mr-1"], [1, "loader-spinner-context", "loader-xs", "white"]], template: function SimpleModalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, SimpleModalFooterComponent_Conditional_1_Template, 5, 1, "div", 1);
        i0.ɵɵconditionalCreate(2, SimpleModalFooterComponent_Conditional_2_Template, 2, 1, "div", 1);
        i0.ɵɵconditionalCreate(3, SimpleModalFooterComponent_Conditional_3_Template, 5, 2, "div", 1);
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵconditionalCreate(5, SimpleModalFooterComponent_Conditional_5_Template, 1, 1, "span", 3);
        i0.ɵɵconditionalCreate(6, SimpleModalFooterComponent_Conditional_6_Template, 1, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵconditionalCreate(8, SimpleModalFooterComponent_Conditional_8_Template, 2, 1, "div", 6);
        i0.ɵɵconditionalCreate(9, SimpleModalFooterComponent_Conditional_9_Template, 1, 4, "div", 7);
        i0.ɵɵconditionalCreate(10, SimpleModalFooterComponent_Conditional_10_Template, 3, 5, "div", 8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.selectedItemCount !== undefined && !ctx.errorText ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.deleteButtonText ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.checkbox ? 3 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.errorText ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.noteText && !ctx.errorText ? 6 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showCancelButton ? 8 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.secondaryButtonText !== undefined ? 9 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showSubmitButton ? 10 : -1);
    } }, dependencies: [i1.NgClass, i1.NgPlural, i1.NgPluralCase, i2.DisabledDirective, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel], encapsulation: 2 });
